import axiosInstance from "./auth";
import { isImpersonating } from "../utils/tokenUtils";

export const searchUsers = async ({
  search = "",
  role = "",
  page = 1,
  limit = 10,
} = {}) => {
  try {
    const params = {
      page,
      limit,
    };

    if (search && search.trim() !== "") {
      params.search = search.trim();
    }

    if (role && role.trim() !== "") {
      params.role = role.trim();
    }

    const response = await axiosInstance.get("/Auth/admin/users", { params });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const impersonateUser = async (userId) => {
  const adminToken = localStorage.getItem("token");
  const adminUser = localStorage.getItem("user");

  if (!adminToken || !adminUser) {
    const sinSesion = "No hay una sesión de administrador activa";
    throw sinSesion;
  }

  if (isImpersonating(adminToken)) {
    const yaSuplantando =
      "Ya estás suplantando a un usuario. Vuelve al panel de administración antes de suplantar a otro.";
    throw yaSuplantando;
  }

  try {
    const response = await axiosInstance.post(
      `/Auth/admin/impersonate/${userId}`,
    );

    if (!response.data || !response.data.token || !response.data.user) {
      const respuestaIncompleta =
        "La respuesta del servidor no incluye la sesión de suplantación";
      throw respuestaIncompleta;
    }

    // Primero se respalda la sesión del admin y se comprueba la escritura.
    localStorage.setItem("admin_token", adminToken);
    localStorage.setItem("admin_user", adminUser);

    if (
      localStorage.getItem("admin_token") !== adminToken ||
      localStorage.getItem("admin_user") !== adminUser
    ) {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      const respaldoFallido =
        "No se pudo guardar la sesión de administrador; se canceló la suplantación";
      throw respaldoFallido;
    }

    // Sólo con el respaldo confirmado se sobrescribe la sesión activa.
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("user", JSON.stringify(response.data.user));

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
